import React, { Component } from 'react';
import SVideoAds from 'shared/screens/VideoAds';
import ImageBW from '../../components/ImageBoundsWrapper';
import './VideoAds.scss';
import ThemeContext from 'shared/context/ThemeContext';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';

export default class Congrats extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-watchAndEarn-Congrats',
      hideBeforeSelector: ENVIRONMENT_VARIABLES.APPLICATION_TARGET === 'hri',
    };
  }

  state = {
    hasSeenCongratsModal: true,
  };

  componentDidMount() {
    window.history.replaceState('', '', window.location.origin);
  }

  render() {
    const themeContext = this.context;
    return (
      <SVideoAds
        navigation={this.props.navigation}
        render={props => {
          const { reward, collectHandler, setHasSeenCongratsModal } = props;
          if (this.state.hasSeenCongratsModal) {
            setHasSeenCongratsModal(true);
          }
          return (
            <div className="watchAndEarnCongratsContainer">
              <span
                style={{
                  textAlign: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  flex: 1,
                  marginTop: '3vmin',
                  height: '6vmin',
                  fontWeight: 600,
                  fontSize: 'calc(18px + (30 - 18) * ((100vw - 800px) / (1600 - 800)))',
                }}
                className={`watchAndEarnGradientText ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                data-label={'CONGRATULATIONS'}
              >
                {getText(TEXT_KEY.CONGRATULATIONS)}
              </span>
              <ImageBW
                source={require(asset`Shop_VIP_Divider_Glows@3x.png`)}
                ibw={require(asset`Shop_VIP_Divider_Glows.ibw`)}
                manualAssetScale={3}
                style={{ height: '7vmin', width: '100%', marginTop: '1vmin' }}
                innerStyle={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-evenly',
                  alignItems: 'center',
                  paddingLeft: '1vmin',
                  paddingRight: '1vmin',
                }}
              ></ImageBW>
              <span className="watchAndEarnPopupIcon">
                <img
                  alt=""
                  src={require(asset`images/Watch_and_Earn_Assets/Coins_Tex@3x.png`)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </span>
              <span style={themeContext.CongratulationsContainer.CongratsSpan}>
                {getText(TEXT_KEY.YOU_HAVE_EARNED)}
              </span>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                  height: '3em',
                }}
              >
                <img
                  src={require(asset`Coin_Icon@3x.png`)}
                  alt=""
                  style={{
                    width: '4%',
                    height: '67%',
                    marginTop: '0.1em',
                    marginRight: '0.7em',
                  }}
                />
                <span
                  style={{
                    fontSize: '1.5em',
                    fontWeight: 600,
                  }}
                  data-label={reward.amount}
                  className={`watchAndEarnGradientText ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                >
                  {reward.amount}
                </span>
              </div>
              <div className="watchAndEarnButton">
                <img
                  alt=""
                  src={require(asset`RoundedRect_Orange@3x.png`)}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
                <span className="watchAndEarnButtonLabel" onClick={() => collectHandler(true)}>
                  {getText(TEXT_KEY.COLLECT_BUTTON)}
                </span>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

Congrats.hideOverlay = true;
Congrats.hideCloseButton = true;
Congrats.contextType = ThemeContext;

